import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "5491122867994"; // tu número con código de país
  const message = "Hola! Quiero hacerte una consulta sobre tus productos y servicios.";
  
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={styles.button}
      aria-label="Consultanos por WhatsApp"
    >
      <span style={styles.text}>Consultanos</span>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="white"
        width="26"
        height="26"
      >
        <path d="M16 0C7.164 0 0 7.163 0 16c0 2.82.736 5.57 2.135 8.003L0 32l8.23-2.095A15.93 15.93 0 0016 32c8.837 0 16-7.164 16-16C32 7.163 24.837 0 16 0zm0 29.09a13.04 13.04 0 01-6.65-1.82l-.477-.284-4.887 1.245 1.305-4.77-.31-.49A13.01 13.01 0 012.91 16C2.91 8.23 8.23 2.91 16 2.91S29.09 8.23 29.09 16 23.77 29.09 16 29.09zm7.2-9.78c-.394-.197-2.33-1.15-2.69-1.28-.36-.132-.62-.197-.88.197-.262.394-1.01 1.28-1.24 1.54-.23.262-.46.295-.853.098-.394-.197-1.66-.612-3.16-1.95-1.17-1.045-1.96-2.334-2.19-2.73-.23-.394-.024-.606.173-.803.177-.176.394-.46.59-.688.197-.23.262-.394.394-.656.132-.262.066-.492-.033-.688-.098-.197-.88-2.12-1.2-2.91-.31-.746-.625-.645-.88-.658l-.75-.014c-.262 0-.688.098-1.05.492-.36.394-1.38 1.35-1.38 3.29 0 1.94 1.41 3.81 1.607 4.07.197.262 2.77 4.23 6.71 5.93.937.404 1.67.646 2.24.827.94.3 1.79.258 2.46.157.75-.11 2.33-.95 2.66-1.87.33-.92.33-1.71.23-1.87-.098-.164-.36-.262-.754-.46z" />
      </svg>
    </a>
  );
};

const styles = {
  button: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    color: "white",
    borderRadius: "30px",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "600",
    fontSize: "14px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    cursor: "pointer",
    zIndex: 1000,
    textDecoration: "none",
  },
  text: {
    whiteSpace: "nowrap",
  },
};

export default WhatsAppButton;
